import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import * as React from "react";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer/settings/useSettingLoggedOutHomepageRedesignV2";
import { LEFT_BANNER_IMAGES, RIGHT_BANNER_IMAGES } from "./__internal__/consts";
import { ForAnyRetailerBannerAnimatedImages } from "./__internal__/ForAnyRetailerBannerAnimatedImages";
import { ForAnyRetailerBannerText } from "./__internal__/ForAnyRetailerBannerText";
export var ForAnyRetailerBanner = function() {
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var ref = useDoActionWhenVisible(function() {
        trackLoggedOutRetailersLoggedOutHomeRedesignView("for_any_retailer_banner", "".concat(homepageRedesignVariant));
    });
    return /*#__PURE__*/ _jsx(SlideIn, {
        bottomThreshold: 100,
        offset: getSpacing("5x"),
        children: /*#__PURE__*/ _jsx(ResponsiveContentV2, {
            tabletAndAbove: /*#__PURE__*/ _jsx(ForAnyRetailerBannerBase, {
                ref: ref
            }),
            mobile: /*#__PURE__*/ _jsx(ForAnyRetailerBannerMobileBase, {
                ref: ref
            })
        })
    });
};
var ForAnyRetailerBannerBase = function(param) {
    var ref = param.ref;
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        justify: "space-between",
        gap: "2x",
        className: "bg-[#595604] p-8 lg:p-12 2xl:px-20 2xl:py-12",
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(ForAnyRetailerBannerAnimatedImages, {
                imageList: LEFT_BANNER_IMAGES
            }),
            /*#__PURE__*/ _jsx(ForAnyRetailerBannerText, {}),
            /*#__PURE__*/ _jsx(ForAnyRetailerBannerAnimatedImages, {
                imageList: RIGHT_BANNER_IMAGES
            })
        ]
    });
};
var ForAnyRetailerBannerMobileBase = function(param) {
    var ref = param.ref;
    return /*#__PURE__*/ _jsxs(Column, {
        align: "flex-start",
        gap: "2x",
        className: "bg-[#595604] p-4 pb-6",
        ref: ref,
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                gap: "1x",
                justify: "space-between",
                className: "w-full",
                children: [
                    /*#__PURE__*/ _jsx(ForAnyRetailerBannerAnimatedImages, {
                        imageList: LEFT_BANNER_IMAGES
                    }),
                    /*#__PURE__*/ _jsx(ForAnyRetailerBannerAnimatedImages, {
                        imageList: RIGHT_BANNER_IMAGES
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ForAnyRetailerBannerText, {})
        ]
    });
};
